import React from "react";

import MuiTextField from "@material-ui/core/TextField";

const TextField = ({ field, form: { handleChange, handleBlur }, ...props }) => (
  <MuiTextField
    name={field.name}
    value={field.value}
    onChange={handleChange}
    onBlur={handleBlur}
    {...props}
  />
);

export default TextField;
